/**
 * Den ENDA window.fetch-patchen i cart-flödet. Fångar mutationsanrop mot
 * varukorgen och kör en (köad) omritning via SRCartRefresh.
 *
 * Historik: tidigare fanns tre oberoende fetch-patchar (denna, GWP-snippeten,
 * cart-optimistic-ui) som lindade varandra och gav upp till tre överlappande
 * DOM-swappar per köp. Nu: en patch, en kö, och eventet `sr:cart-mutated`
 * som GWP-syncen m.fl. prenumererar på i stället för att patcha själva.
 *
 *   /cart/add            → refresh + öppna lådan + event
 *   /cart/change|update|clear → enbart event (temats theme.js sköter sin egen
 *                          omritning för qty-ändringar; en refresh till här
 *                          skulle ge dubbelswappen tillbaka)
 */
(function () {
  'use strict';

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var isAdd = typeof url === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(url);
    var isOtherMutation = typeof url === 'string' && /\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url);

    if (!isAdd && !isOtherMutation) return origFetch.apply(this, arguments);

    return origFetch.apply(this, arguments).then(function (response) {
      if (!response.ok) return response;
      var clone = response.clone();
      if (isAdd && window.SRCartRefresh) {
        window.SRCartRefresh.refresh()
          .then(function () { window.SRCartRefresh.openDrawer(); })
          .catch(function () {});
      }
      document.dispatchEvent(new CustomEvent('sr:cart-mutated', {
        detail: { url: url, kind: isAdd ? 'add' : 'change' }
      }));
      return clone;
    });
  };
})();
